export default "__VITE_ASSET__jch9kWkV__"